/* eslint-disable import/no-dynamic-require */
import React, { useState } from 'react';
import {
  Grid,
  Row,
  Col,
  Modal,
  Space,
} from 'antd';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import {
  FlexCol,
  Title,
  Text,
  Button,
  Card,
  COLORS,
} from 'components';
import {
  ENV_NAME,
  ENV_NAMES_ENUM,
  IPROVINAY,
  PROD,
  REPUVE,
} from 'utils/env';
import { logoHeader, publicidad } from 'assets';
import Previewer from 'components/Previewer';
import File1 from 'assets/navojoa/files/ANUENCIA_MUNICIPAL_PARA_PARTICULARES_2024.pdf';
import File2 from 'assets/navojoa/files/CARTA_DE_RESIDENCIA_2024.pdf';
import File3 from 'assets/navojoa/files/ANUENCIA_MUNICIPAL_PARA_COMITES_2024.pdf';
// import Carousels from 'components/Carousels';
// import News from 'views/News/NewsList';

const CardsNayarit = () => {
  const [previewUrl, setPreviewUrl] = useState('');
  const [showInstructivo, setShowInstructivo] = useState(false);

  // eslint-disable-next-line global-require
  const doc = require('../assets/nayarit/instructivos/IMPUESTOSESTATALES2024.pdf');

  return (
    <Col className="card-container" xs={24} sm={24} md={12}>
      <Card style={{ height: '100%' }} bg={COLORS.gray}>
        <Title level={3} color={COLORS.white}>
          Padrón Estatal
        </Title>
        <Text color={COLORS.white}>
          Descarga los formatos de los servicios relacionados al Padrón Estatal.
        </Text>
        <Button
          style={{ margin: '10px 0' }}
          color={COLORS.white}
          block
          onClick={() => {
            const url = 'https://opensir.sfo2.digitaloceanspaces.com/opensir/media/formato-de-devolucio%CC%81n-de-impuestos-estatales.pdf';
            setPreviewUrl(url);
          }}
        >
          Formato de devolución de impuestos estatales
        </Button>
        <Button
          color={COLORS.white}
          block
          onClick={() => {
            const url = 'https://opensir.sfo2.digitaloceanspaces.com/opensir/media/formato-de-inscripcion-o-movimientos-posteriores-al-padron-estatal.pdf';
            setPreviewUrl(url);
          }}
        >
          Formato de inscripción o movimientos posteriores al padrón estatal
        </Button>
        <Button
          style={{ margin: '10px 0' }}
          color={COLORS.white}
          block
          onClick={() => setShowInstructivo(true)}
        >
          Constancia de Retenciones a Impuestos Estatales
        </Button>
        {
          showInstructivo && (
            <Modal
              title="CONSTANCIA DE RETENCIONES DE IMPUESTOS ESTATALES"
              visible={showInstructivo}
              onCancel={() => setShowInstructivo(false)}
              footer={null}
              width="80%"
            >
              <Col span={24}>
                <iframe
                  title="Instructivo"
                  src={doc.default}
                  width="100%"
                  height="800px"
                />
              </Col>
            </Modal>
          )
        }
      </Card>
      <Previewer
        visible={!!previewUrl}
        onCancel={() => setPreviewUrl('')}
        iFrameUrl={previewUrl}
      />
    </Col>
  );
};

const cards = {
  [ENV_NAMES_ENUM.OAXACA]: {
    title: 'VENTANILLA ÚNICA',
    subTitle: 'Portal de Atención al Contribuyente',
    welcomeText: 'Bienvenido a la ventanilla única, donde puedes consultar, realizar, pagar tus trámites y servicios en línea, así como localizar las oficinas de atención.',
    colorTextCard: '',
    colorButtonCard: '',
    // titleCard1: 'Realiza tus pagos y obtén tu factura aquí.',
    bodyTextCard: 'Ya puedes realizar pagos de contribuciones, derechos, servicios y pagos de diversos',
    cards: (
      <>
        <Col className="card-container" xs={24} sm={24} md={12}>
          <Card style={{ height: '100%' }} bg={COLORS.cream2}>
            <Title level={3} $centered>
              Ligas de interés
            </Title>
            <Button block style={{ marginTop: 30 }} color="black">
              <a
                href="https://transparencia.municipiodeoaxaca.gob.mx/desarrollo-economico/ECEO"
                target="_blank"
                rel="noreferrer"
              >
                Transparencia Económica
              </a>
            </Button>
            <Button block style={{ marginTop: 10 }} color="black">
              <a
                href="https://mejoraregulatoria.municipiodeoaxaca.gob.mx/tramites-y-servicios"
                target="_blank"
                rel="noreferrer"
              >
                Mejora Regulatoria
              </a>
            </Button>
            <Button block style={{ marginTop: 10 }} color="black">
              <a
                href="https://imli.municipiodeoaxaca.gob.mx/"
                target="_blank"
                rel="noreferrer"
              >
                Instituto Municipal de las lenguas Indígenas
              </a>
            </Button>
          </Card>
        </Col>
        <Col className="card-container" xs={24} sm={24} md={12}>
          <Card
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
            bg={COLORS.gray}
          >
            <Title
              $centered
              level={3}
              color={COLORS.white}
              style={{ flex: 1 }}
            >
              Guías de ayuda
            </Title>
            <Text color={COLORS.white}>
              En esta sección puedes descargar guías de ayuda para realizar citas y trámites
            </Text>
            <Button
              block
              style={{ marginTop: 'auto' }}
              color={COLORS.white}
              disabled
              // onClick={() => window.open('https://iprovinay.gob.mx/nosotros.html')}
            >
              Descarga Guía para realizar tu cita
            </Button>
            <Button
              color={COLORS.white}
              style={{ marginTop: 10 }}
              block
              disabled
              // onClick={() => window.open('https://iprovinay.gob.mx/que%20hacemos.html')}
            >
              Información de Trámites
            </Button>
          </Card>
        </Col>
      </>
    ),
  },
  [ENV_NAMES_ENUM.NAVOJOA]: {
    title: 'Trámites y Servicios digitales en línea en el Gobierno Municipal de Navojoa',
    colorTextCard: '',
    colorButtonCard: '',
    // titleCard1: 'Realiza tus pagos y obtén tu factura aquí.',
    bodyTextCard: 'Ya puedes realizar pagos de contribuciones, derechos, servicios y pagos de diversos',
    cards: (
      <>
        <Col className="card-container" xs={24} sm={24} md={12}>
          <Card style={{ height: '100%' }} bg={COLORS.cream}>
            <Title level={3} $centered>
              Ligas de interés
            </Title>
            <Button
              block
              style={{ marginTop: 30 }}
              color="black"
              onClick={() => window.open(File1)}
            >
              Anuencia para eventos Familiares
            </Button>
            <Button
              block
              style={{ marginTop: 10 }}
              color="black"
              onClick={() => window.open(File2)}
            >
              Carta de residencia
            </Button>
            <Button
              block
              style={{ marginTop: 10 }}
              color="black"
              onClick={() => window.open(File3)}
            >
              Anuencia para eventos Comités
            </Button>
          </Card>
        </Col>
        <Col className="card-container" xs={24} sm={24} md={12}>
          <Card
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
            bg={COLORS.gray}
          >
            <Title
              $centered
              level={3}
              color={COLORS.white}
              style={{ flex: 1 }}
            >
              Guías de ayuda
            </Title>
            <Text color={COLORS.white}>
              En esta sección puedes descargar guías de ayuda para realizar citas y trámites
            </Text>
            <Button
              block
              style={{ marginTop: 'auto' }}
              color={COLORS.white}
            >
              Descarga Guía para realizar tu cita
            </Button>
            <Button
              color={COLORS.white}
              style={{ marginTop: 10 }}
              block
            >
              Información de Trámites
            </Button>
          </Card>
        </Col>
      </>
    ),
  },
  [ENV_NAMES_ENUM.SALAMANCA]: {
    title: 'PLATAFORMA DE INFRACCIONES DIGITALES',
    subTitle: 'DIRECCIÓN GENERAL DE MOVILIDAD Y DIRECCIÓN DE TRÁNSITO Y VIALIDAD',
    welcomeText: 'TRÁNSITO, VIALIDAD Y TRANSPORTE DEL MUNICIPIO DE SALAMANCA',

    colorTextCard: '',
    colorButtonCard: '',
    accent: '#8E1830',
    // titleCard1: 'Realiza tus pagos y obtén tu factura aquí.',
    bodyTextCard: 'Ya puedes realizar pagos de contribuciones, derechos, servicios y pagos de diversos',
    cards: (
      <>
        <Col className="card-container" xs={24} sm={24} md={12}>
          <Card style={{ height: '100%' }} bg={COLORS.cream}>
            <Title level={3} $centered>
              Ligas de interés
            </Title>
            <Button
              block
              style={{ marginTop: 30 }}
              color="black"
              onClick={() => window.open('http://salamanca.gob.mx/')}
            >
              Portal Oficial del Municipio de Salamanca, Gto.
            </Button>
            <Button
              block
              style={{ marginTop: 10 }}
              color="black"
              onClick={() => window.open('http://tramites.salamanca.gob.mx/')}
            >
              Portal de Trámites y Servicios
            </Button>
          </Card>
        </Col>
        {/* <Col className="card-container" xs={24} sm={24} md={12}>
          <Card
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
            bg={COLORS.gray}
          >
            <Title
              $centered
              level={3}
              color={COLORS.white}
              style={{ flex: 1 }}
            >
              Guías de ayuda
            </Title>
            <Text color={COLORS.white}>
              En esta sección puedes descargar guías de ayuda para realizar citas y trámites
            </Text>
            <Button
              block
              style={{ marginTop: 'auto' }}
              color={COLORS.white}
            >
              Descarga Guía para realizar tu cita
            </Button>
            <Button
              color={COLORS.white}
              style={{ marginTop: 10 }}
              block
            >
              Información de Trámites
            </Button>
          </Card>
        </Col> */}
      </>
    ),
  },
  [ENV_NAMES_ENUM.NAYARIT]: {
    title: 'VENTANILLA ÚNICA',
    subTitle: 'Portal de Atención al Contribuyente',
    welcomeText: 'Bienvenido a la ventanilla única, donde puedes consultar, realizar, pagar tus trámites y servicios en línea, así como localizar las oficinas de atención.',
    colorTextCard: '',
    colorButtonCard: '',
    titleCard1: 'Realiza tus pagos y obtén tu factura aquí.',
    bodyTextCard: 'Ya puedes realizar pagos de contribuciones, derechos, servicios y pagos de diversos',
    cards: (<CardsNayarit />),
  },
  [ENV_NAMES_ENUM.JUAREZ]: {
    title: 'VENTANILLA VIRTUAL',
    titleAccent: false,
    // subTitle: 'de Atención Ciudadana',
    // welcomeText: 'Bienvenido a la ventanilla única, donde puedes consultar, realizar
    // y pagar tus trámites y servicios en línea, así como localizar las oficinas de atención.',
    colorTextCard: 'white',
    colorButtonCard: COLORS.white,
    titleCard1: 'Realiza pagos y obtén tu factura',
    bodyTextCard: 'Puedes realizar el pago de impuestos, trámites, servicios, multas y otros.',
    cards: (
      <Col className="card-container" xs={24} sm={24} md={12}>
        <Card style={{ height: '100%' }} bg={COLORS.gray}>
          <Title level={3} color={COLORS.white}>
            Información de interés
          </Title>
          <Text color={COLORS.white}>
            Encuentra información complementaria para tus trámites y servicios.
          </Text>
          <Button style={{ margin: '10px 0' }} color={COLORS.white} block>
            <Link to="/oficinas">
              Oficinas de atención
            </Link>
          </Button>
          <Button color={COLORS.white} block>
            <Link to="/normateca">
              Consultar normatividad
            </Link>
          </Button>
        </Card>
      </Col>
    ),
  },
  [ENV_NAMES_ENUM.HERMOSILLO]: {
    title: 'VENTANILLA ÚNICA',
    subTitle: 'de Atención Ciudadana',
    subTitleColor: 'white',
    welcomeText: 'Bienvenido a la ventanilla única, donde puedes consultar, realizar y pagar tus trámites y servicios en línea, así como localizar las oficinas de atención.',
    colorTextCard: 'white',
    colorButtonCard: COLORS.white,
    titleCard1: 'Realiza pagos y obtén tu factura',
    bodyTextCard: 'Puedes realizar el pago de impuestos, trámites, servicios, multas y otros.',
    cards: (
      <Col className="card-container" xs={24} sm={24} md={12}>
        <Card style={{ height: '100%' }} bg={COLORS.gray}>
          <Title level={3} color={COLORS.white}>
            Información de interés
          </Title>
          <Text color={COLORS.white}>
            Encuentra información complementaria para tus trámites y servicios.
          </Text>
          <Button style={{ margin: '10px 0' }} color={COLORS.white} block>
            <Link to="/oficinas">
              Oficinas de atención
            </Link>
          </Button>
          <Button color={COLORS.white} block>
            <Link to="/normateca">
              Consultar normatividad
            </Link>
          </Button>
        </Card>
      </Col>
    ),
  },
  [ENV_NAMES_ENUM.ROATAN]: {
    title: 'VENTANILLA ÚNICA',
    subTitle: 'Portal de Atención al Contribuyente',
    welcomeText: 'Bienvenido a la ventanilla única, donde puedes consultar, realizar, pagar tus trámites y servicios en línea, así como localizar las oficinas de atención.',
    colorTextCard: '',
    colorButtonCard: '',
    bodyTextCard: 'Ya puedes realizar pagos de contribuciones, derechos, servicios y pagos de diversos',
    cards: (
      <>
        <Col className="card-container" xs={24} sm={24} md={12}>
          <Card style={{ height: '100%' }} bg={COLORS.cream2}>
            <Title level={3}>
              Ligas de interés
            </Title>
            <Text>
              Consulta de sitios de interés
            </Text>
            <Button block style={{ marginTop: 40 }}>
              <a
                href="https://portalunico.iaip.gob.hn/portal=190"
                target="_blank"
                rel="noreferrer"
              >
                Portal Único de Transparencia
              </a>
            </Button>
            <Button block style={{ marginTop: 10 }}>
              <a
                href="https://amhon.hn/interes-municipal/"
                target="_blank"
                rel="noreferrer"
              >
                Interés Municipal (AMHON)
              </a>
            </Button>
          </Card>
        </Col>
        <Col className="card-container" xs={24} sm={24} md={12}>
          <Card style={{ height: '100%' }} bg={COLORS.gray}>
            <Title level={3} color={COLORS.white}>
              Guías de ayuda
            </Title>
            <Text color={COLORS.white}>
              En esta sección puedes descargar guías de ayuda para realizar citas y trámites
            </Text>
            <Button disabled block style={{ marginTop: 57 }} color={COLORS.white}>
              <Link
                download
                target="_blank"
                to="/files/guia-para-realizar-cita.pdf"
                style={{ cursor: 'not-allowed', pointerEvents: 'none' }}
              >
                Descarga Guía para realizar tu cita
              </Link>
            </Button>
            <Button color={COLORS.white} style={{ marginTop: 10 }} block>
              <Link to="/tramites">
                Información de Trámites
              </Link>
            </Button>
          </Card>
        </Col>
      </>
    ),
  },
};

const cardsRepuve = {
  title: 'Registro Público Vehicular de Nayarit',
  subTitle: 'Sistema Estatal de Seguridad Pública',
  welcomeText: 'Bienvenido al nuevo portal digital donde puedes consultar requisitos de trámites, realizar citas en línea, ubicar módulos de atención para poder atenderte con mayor agilidad.',
  colorTextCard: '',
  colorButtonCard: '',
  cards: (
    <>
      <Col className="card-container" xs={24} sm={24} md={12}>
        <Card style={{ height: '100%' }} bg={COLORS.cream2}>
          <Title level={3}>
            Ligas de interés
          </Title>
          <Text>
            Consulta de sitios de interés
          </Text>
          <Button block style={{ marginTop: 40 }}>
            <a
              href="https://regularizaauto.sspc.gob.mx/"
              target="_blank"
              rel="noreferrer"
            >
              Regulariza tu Auto (Sistema de Citas)
            </a>
          </Button>
          <Button block style={{ marginTop: 10 }}>
            <a
              href="https://www2.repuve.gob.mx:8443/ciudadania/"
              target="_blank"
              rel="noreferrer"
            >
              REPUVE Consulta Ciudadana
            </a>
          </Button>
          <Button block style={{ marginTop: 10 }}>
            <a
              href="https://hacienda.minayarit.gob.mx/tramites"
              target="_blank"
              rel="noreferrer"
            >
              Trámites Vehiculares (Secretaría de Administración y Finanzas)
            </a>
          </Button>
        </Card>
      </Col>
      <Col className="card-container" xs={24} sm={24} md={12}>
        <Card style={{ height: '100%' }} bg={COLORS.gray}>
          <Title level={3} color={COLORS.white}>
            Guías de ayuda
          </Title>
          <Text color={COLORS.white}>
            En esta sección puedes descargar guías de ayuda para realizar citas y trámites
          </Text>
          <Button disabled block style={{ marginTop: 57 }} color={COLORS.white}>
            <Link
              download
              target="_blank"
              to="/files/guia-para-realizar-cita.pdf"
              style={{ cursor: 'not-allowed', pointerEvents: 'none' }}
            >
              Descarga Guía para realizar tu cita
            </Link>
          </Button>
          <Button color={COLORS.white} style={{ marginTop: 10 }} block>
            <Link to="/tramites">
              Información de Trámites
            </Link>
          </Button>
        </Card>
      </Col>
    </>
  ),
};

const cardsIprovinay = {
  title: 'VENTANILLA VIRTUAL',
  welcomeText: 'Bienvenido al nuevo Portal Ciudadano del Instituto Promotor para la vivienda de Nayarit, donde puedes consultar, realizar, pagar tus trámites y servicios en línea.',
  welcomeTextSize: '20px',
  colorTextCard: '',
  colorButtonCard: '',
  bodyTextCard: 'Ya puedes realizar pagos de contribuciones, derechos, servicios y pagos de diversos',
  cards: (
    <>
      <Col className="card-container" xs={24} sm={24} md={12}>
        <Card style={{ height: '100%' }} bg={COLORS.cream2}>
          <Title level={3} $centered>
            Transparencia
          </Title>
          <Button block style={{ marginTop: 30 }}>
            <a
              href="https://transparencia.nayarit.gob.mx/index.php?option=com_wrapper&view=wrapper&Itemid=490"
              target="_blank"
              rel="noreferrer"
            >
              Portal Único de Transparencia y Acceso a la Información Pública del Estado de Nayarit
            </a>
          </Button>
          <Button block style={{ marginTop: 10 }}>
            <a
              href="https://iprovinay.gob.mx/srtf.html"
              target="_blank"
              rel="noreferrer"
            >
              Informes Trimetrales
            </a>
          </Button>
        </Card>
      </Col>
      <Col className="card-container" xs={24} sm={24} md={12}>
        <Card
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
          bg={COLORS.gray}
        >
          <Title
            $centered
            level={3}
            color={COLORS.white}
            style={{ flex: 1 }}
          >
            El Instituto
          </Title>
          <Button
            block
            style={{ marginTop: 'auto' }}
            color={COLORS.white}
            onClick={() => window.open('https://iprovinay.gob.mx/nosotros.html')}
          >
            Nosotros
          </Button>
          <Button
            color={COLORS.white}
            style={{ marginTop: 10 }}
            block
            onClick={() => window.open('https://iprovinay.gob.mx/que%20hacemos.html')}
          >
            Que hacemos
          </Button>
        </Card>
      </Col>
    </>
  ),
};

const homeInfo = (IPROVINAY && cardsIprovinay) || (REPUVE && cardsRepuve) || (cards[ENV_NAME]);

const Home = () => {
  const screens = Grid.useBreakpoint();
  const navigate = useNavigate();
  const [visiblebanner, setVisiblebanner] = useState(ENV_NAME === 'nayarit' && !REPUVE);

  const styles = !screens.xl
    ? { height: '60%', display: 'flex', justifyContent: 'flex-start' }
    : { height: '100%' };

  // const width = {
  //   [ENV_NAMES_ENUM.NAVOJOA]: screens.xs ? '90%' : '45%',
  // };

  const titleStyle = {
    marginTop: 15,
    width: '45%',
    textAlign: 'center',
  };

  return (
    <>
      <div className="home">
        <FlexCol flex="1" style={styles}>
          <Logo />
          <Title
            level={screens.xs ? 2 : 1}
            $accent={homeInfo.titleAccent}
            style={titleStyle}
          >
            {homeInfo.title}
          </Title>
          {!!homeInfo.subTitle && (
            <Title
              level={screens.xs ? 3 : 2}
              color={homeInfo.accent}
              style={{ marginBottom: 15, marginTop: 0 }}
            >
              {homeInfo.subTitle}
            </Title>
          )}
          {!!homeInfo.welcomeText && (
            <Text
              style={{
                maxWidth: screens.md ? '40vw' : '70vw',
                textAlign: 'center',
                mixBlendMode: 'multiply',
                fontSize: homeInfo?.welcomeTextSize ?? 18,
              }}
            >
              {homeInfo.welcomeText}
            </Text>
          )}
          {REPUVE && ENV_NAME === ENV_NAMES_ENUM.NAYARIT && (
            <Space style={{ marginTop: 15 }}>
              <Button block={!screens.md}>
                <Link to="/tramites">
                  <Text strong>
                    Trámites
                  </Text>
                </Link>
              </Button>
              {/* <Button block={!screens.md}>
                <Link
                  target="_blank"
                  to="https://www2.repuve.gob.mx:8443/ciudadania/"
                >
                  Consulta Ciudadana
                </Link>
              </Button> */}
              <Button block={!screens.md} $accent>
                <Link to="/citas">
                  <Text strong>
                    Agenda tu cita aquí
                  </Text>
                </Link>
              </Button>
            </Space>
          )}
          {!IPROVINAY && ENV_NAME === ENV_NAMES_ENUM.JUAREZ && (
            <>
              <Text
                strong
                style={{
                  maxWidth: screens.md ? '40vw' : '70vw',
                  textAlign: 'center',
                  mixBlendMode: 'multiply',
                }}
              >
                Pagos y Trámites frecuentes:
              </Text>
              <Row
                gutter={[10, 10]}
                style={{ width: '90%', marginTop: 15 }}
              >
                <Col xs={24} sm={24} md={8}>
                  <Button block $accent>
                    <Link to="/tramites/?q=traslacion">
                      Traslaciones
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button block $accent>
                    <Link to="/tramites/?q=licencia">
                      Licencias
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button block $accent>
                    <Link to="/tramites/?q=constancia">
                      Constancias
                    </Link>
                  </Button>
                </Col>
              </Row>
            </>
          )}
          {!REPUVE && ENV_NAME === ENV_NAMES_ENUM.NAYARIT && (
            <>
              <br />
              <Text
                strong
                style={{
                  maxWidth: screens.md ? '40vw' : '70vw',
                  textAlign: 'center',
                  mixBlendMode: 'multiply',
                }}
              >
                Pagos Frecuentes:
              </Text>
              <Row style={{ marginTop: 15, width: screens.md ? '80%' : '100%' }} gutter={[10, 10]}>
                <Col xs={24} sm={24} md={6}>
                  <Button block $accent>
                    <Link to="/pagos/consulta-de-adeudos/vehiculo-4">
                      Refrendo Vehicular
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={6}>
                  <Button block $accent>
                    <Link to="/pagos/consulta-de-adeudos/alcohol-9">
                      Refrendo de Alcoholes
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={6}>
                  <Button block $accent>
                    <Link to="/pagos/pago-de-derechos-03">
                      Pago de Derechos
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={6}>
                  <Button block $accent>
                    <Link to="pagos/pago-de-impuestos-estatales-01">
                      Pago de impuestos estatales
                    </Link>
                  </Button>
                </Col>
              </Row>
              <br />
              {!PROD && (
                <>
                  <Text
                    strong
                    style={{
                      maxWidth: screens.md ? '40vw' : '70vw',
                      textAlign: 'center',
                      mixBlendMode: 'multiply',
                    }}
                  >
                    Trámites Frecuentes:
                  </Text>
                  <Row
                    gutter={[10, 10]}
                    style={{ marginTop: 15, width: screens.md ? '80%' : '100%' }}
                  >
                    <Col xs={24} sm={24} md={8}>
                      <Button block $accent>
                        <Link
                          to={`/tramites/?q=${
                            encodeURIComponent('INSCRIPCIÓN A IMPUESTOS ESTATALES EN LÍNEA')}`}
                        >
                          Inscripción en Línea al Padrón Estatal
                        </Link>
                      </Button>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Button block $accent>
                        <Link to="/pagos/consulta-de-adeudos/alcohol-9">
                          Módulos de Avisos posteriores al Padrón Estatal
                        </Link>
                      </Button>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Button block $accent>
                        <Link to="/pagos/pago-de-derechos-03">
                          Módulo de Trámites Vehiculares
                        </Link>
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </>
          )}
          {!IPROVINAY && ENV_NAME === ENV_NAMES_ENUM.ROATAN && (
            <>
              <br />
              <Text
                strong
                style={{
                  maxWidth: screens.md ? '40vw' : '70vw',
                  textAlign: 'center',
                  mixBlendMode: 'multiply',
                }}
              >
                Pagos Frecuentes:
              </Text>
              <Row style={{ marginTop: 15, width: '70%' }} gutter={[10, 10]}>
                <Col xs={24} sm={24} md={8}>
                  <Button $accent style={{ width: '100%', padding: 10, borderRadius: 8 }}>
                    <Link to="/tramites/?q=permiso">
                      Permisos
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button $accent style={{ width: '100%', padding: 10, borderRadius: 8 }}>
                    <Link to="/tramites/?q=constancia">
                      Constancia
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button $accent style={{ width: '100%', padding: 10, borderRadius: 8 }}>
                    <Link to="/tramites/?q=impuesto">
                      Impuestos
                    </Link>
                  </Button>
                </Col>
              </Row>
            </>
          )}
          {IPROVINAY && ENV_NAME === ENV_NAMES_ENUM.NAYARIT && (
            <>
              <br />
              <Text
                strong
                style={{
                  maxWidth: screens.md ? '40vw' : '70vw',
                  textAlign: 'center',
                  mixBlendMode: 'multiply',
                }}
              >
                Tramites y Pagos Frecuentes
              </Text>
              <Row style={{ marginTop: 15, width: '70%' }} gutter={[10, 10]}>
                <Col xs={24} sm={24} md={8}>
                  <Button block $accent>
                    <Link to="/tramites/?q=pago de lotes">
                      Pago de Lotes
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button block $accent>
                    <Link to="/tramites/?q=pago de escrituras">
                      Pago de escrituras
                    </Link>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button block $accent>
                    <Link to="/tramites/?q=mejora tu vivienda">
                      Mejora tu vivienda
                    </Link>
                  </Button>
                </Col>
              </Row>
            </>
          )}
          {!IPROVINAY && ENV_NAME === ENV_NAMES_ENUM.OAXACA && (
          <>
            <br />
            <Text
              strong
              style={{
                maxWidth: screens.md ? '40vw' : '70vw',
                textAlign: 'center',
                mixBlendMode: 'multiply',
              }}
            >
              Pagos Frecuentes:
            </Text>
            <Row
              style={{ marginTop: 15, width: '70%' }}
              gutter={[10, 10]}
              justify="center"
            >
              <Col xs={24} sm={24} md={8}>
                <Button $accent style={{ width: '100%', padding: 10, borderRadius: 8 }}>
                  <Link to="/pagos/consulta-de-adeudos/predio-3">
                    <Text>
                      Pago de predial
                    </Text>
                  </Link>
                </Button>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Button $accent style={{ width: '100%', padding: 10, borderRadius: 8 }}>
                  <Link to="/pagos/consulta-de-adeudos/panteon-31">
                    <Text>
                      Pago de panteón
                    </Text>
                  </Link>
                </Button>
              </Col>
            </Row>
          </>
          )}
        </FlexCol>
      </div>
      {/* <Carousels />
      <News home /> */}
      <Row gutter={[20, 20]} justify="center" style={{ paddingLeft: 10 }}>
        {!!homeInfo.titleCard1 && (
          <Col className="card-container" xs={24} sm={24} md={12}>
            <Card style={{ height: '100%' }} bg={COLORS.cream2} className="col">
              <Title level={3} color={homeInfo.colorTextCard}>
                {homeInfo.titleCard1}
              </Title>
              <Text color={homeInfo.colorTextCard}>
                {homeInfo.bodyTextCard}
              </Text>
              <Button style={{ margin: '10px 0' }} color={homeInfo.colorButtonCard} block>
                <Link to="/pagos">
                  Consultar tipos de pagos
                </Link>
              </Button>
              <Button
                block
                color={homeInfo.colorButtonCard}
                onClick={() => {
                  const action = {
                    [ENV_NAMES_ENUM.JUAREZ]: () => window.open('https://www.juarez.gob.mx/facturacion/'),
                    [ENV_NAMES_ENUM.NAYARIT]: () => navigate('/facturacion'),
                    [ENV_NAMES_ENUM.HERMOSILLO]: () => navigate('/facturacion'),
                    [ENV_NAMES_ENUM.ROATAN]: () => navigate('/facturacion'),
                  }[ENV_NAME];
                  if (action) {
                    action();
                  }
                }}
              >
                Facturación electrónica
              </Button>
            </Card>
          </Col>
        )}
        {homeInfo.cards}
      </Row>
      <Modal
        width={screens.xs ? '100%' : '25%'}
        visible={visiblebanner}
        footer={(
          <>
            <Button
              $accent
              block
              style={{ marginTop: -20 }}
            >
              <a
                href="https://hacienda.minayarit.gob.mx/pagos/consulta-de-adeudos/vehiculo-4"
                target="_blank"
                rel="noreferrer"
              >
                Consultar adeudos vehiculares
              </a>
            </Button>
            <Button
              $accent
              style={{ width: '100%', marginLeft: 0, marginTop: 10 }}
              onClick={() => setVisiblebanner(false)}
            >
              Cerrar
            </Button>
          </>
        )}
        onCancel={() => {
          setVisiblebanner(false);
        }}
      >
        <Publicidad />
      </Modal>
    </>
  );
};

const Logo = styled.img.attrs(({
  src: logoHeader,
  alt: 'logo',
}))`
  width: 320px;
  margin-bottom: 35px;
  @media only screen and (max-width: 992px) {
    margin-left: auto;
    margin-right: auto;
    width: 300px;
  }
`;

const Publicidad = styled.img.attrs(({
  src: publicidad,
  alt: 'publicidad',
}))`
  width: 100%;
  height: 65vh;
`;

export default Home;
